import axios from 'axios';
import { getStorage } from '../../helper/localStorage';
import { API_ENDPOINT } from '../../utils/constants';

export const getUseProfileData = async () => {
  var users = getStorage('user');
  if (users) {
    users = JSON.parse(users);
    const options = {
      url: `${API_ENDPOINT}/getUserProfile`,
      method: 'POST',
      headers: {
        'x-access-token': users.accessToken,
      },
    };
    const response = await axios(options).catch(err => {
      console.log(err.response);
    });
    return response.data;
  } else {
    return [];
  }
};
export const updateUseProfile = async data => {
  var users = getStorage('user');
  if (users) {
    users = JSON.parse(users);
    const options = {
      url: `${API_ENDPOINT}/updateProfile`,
      method: 'POST',
      data: data,
      headers: {
        'x-access-token': users.accessToken,
      },
    };
    const response = await axios(options).catch(err => {
      console.log(err.response);
    });
    return response.data;
  } else {
    return [];
  }
};
